/* eslint-disable @typescript-eslint/naming-convention */
import { Dispatch } from 'react';

import { LoanTerms } from '../common/types';

export interface RentOrBuyState {
  monthlyRent: number;
  expectedAnnualRentIncrease: number;
  homePrice: number;
  downPayment: number;
  downPaymentPercent: number;
  closingCostPercent: number;
  interestRate: number;
  loanTerm: LoanTerms;
  annualAppreciation: number;
  howLongBeforeSelling: number;
  currentAnnualInterest: number;
  incomeTax: number;
  showFull: boolean;
}

export enum RentOrBuyActionTypes {
  SET_MONTHLY_RENT,
  SET_EXPECTED_ANNUAL_RENT_INCREASE,
  SET_HOME_PRICE,
  SET_DOWN_PAYMENT,
  SET_DOWN_PAYMENT_PERCENT,
  SET_CLOSING_COST_PERCENT,
  SET_INTEREST_RATE,
  SET_LOAN_TERM,
  SET_ANNUAL_APPRECIATION,
  SET_HOW_LONG_BEFORE_SELLING,
  SET_CURRENT_ANNUAL_INTEREST,
  SET_INCOME_TAX,
  SET_SHOW_FULL,
  SET_DEFAULTS
}

export type RentOrBuyActions =
  | {
      type: RentOrBuyActionTypes.SET_MONTHLY_RENT;
      payload: RentOrBuyState['monthlyRent'];
    }
  | {
      type: RentOrBuyActionTypes.SET_EXPECTED_ANNUAL_RENT_INCREASE;
      payload: RentOrBuyState['expectedAnnualRentIncrease'];
    }
  | {
      type: RentOrBuyActionTypes.SET_HOME_PRICE;
      payload: RentOrBuyState['homePrice'];
    }
  | {
      type: RentOrBuyActionTypes.SET_DOWN_PAYMENT;
      payload: RentOrBuyState['downPayment'];
    }
  | {
      type: RentOrBuyActionTypes.SET_DOWN_PAYMENT_PERCENT;
      payload: RentOrBuyState['downPaymentPercent'];
    }
  | {
      type: RentOrBuyActionTypes.SET_CLOSING_COST_PERCENT;
      payload: RentOrBuyState['closingCostPercent'];
    }
  | {
      type: RentOrBuyActionTypes.SET_INTEREST_RATE;
      payload: RentOrBuyState['interestRate'];
    }
  | {
      type: RentOrBuyActionTypes.SET_LOAN_TERM;
      payload: RentOrBuyState['loanTerm'];
    }
  | {
      type: RentOrBuyActionTypes.SET_ANNUAL_APPRECIATION;
      payload: RentOrBuyState['annualAppreciation'];
    }
  | {
      type: RentOrBuyActionTypes.SET_HOW_LONG_BEFORE_SELLING;
      payload: RentOrBuyState['howLongBeforeSelling'];
    }
  | {
      type: RentOrBuyActionTypes.SET_CURRENT_ANNUAL_INTEREST;
      payload: RentOrBuyState['currentAnnualInterest'];
    }
  | {
      type: RentOrBuyActionTypes.SET_INCOME_TAX;
      payload: RentOrBuyState['incomeTax'];
    }
  | {
      type: RentOrBuyActionTypes.SET_SHOW_FULL;
      payload: RentOrBuyState['showFull'];
    }
  | {
      type: RentOrBuyActionTypes.SET_DEFAULTS;
    };

export type RentOrBuyContextType = {
  state: RentOrBuyState;
  dispatch: Dispatch<RentOrBuyActions>;
  getCurrentValueOfHome: () => number;
  getTotalOwedToBank: () => number;
  getEquityOnHome: () => number;
  getNetCostOfBuying: () => number;
  getNetCostOfRenting: () => number;
  getBenefitOfBuying: () => number;
};
